/**
 * Auth0 SPA client singleton for use outside React (loaders, actions, middleware).
 * Uses @auth0/auth0-spa-js so tokens and redirect handling work without React hooks.
 */
import { Auth0Client } from '@auth0/auth0-spa-js';
import { getConfig } from 'src/config/config';
import { getEnvironment } from 'src/config/environment';
import { Environment } from 'src/types/env';

const config = getConfig();
export const auth0Client = new Auth0Client({
  domain: config.auth0Domain,
  clientId: config.auth0ClientId,
  authorizationParams: {
    redirect_uri: window.location.origin + '/callback',
    audience: config.auth0Audience,
    scope: 'openid profile email offline_access',
    prompt: 'login',
    connection: config.auth0Connection,
  },
  cacheLocation: 'localstorage',
  useRefreshTokens: true,
  useRefreshTokensFallback: false,
  useCookiesForTransactions: true,
  cookieDomain: getCookieDomain(),
});

function getCookieDomain(): string | undefined {
  const environment = getEnvironment();
  if ([Environment.Local, Environment.Development].includes(environment)) {
    return undefined;
  } else if (
    [Environment.Staging, Environment.Production].includes(environment)
  ) {
    return '.artera.ai';
  }
}
